import React, { Fragment, useContext, useState, useEffect } from "react";
import makeStyles from "@mui/styles/makeStyles";
import { MediaContext } from "../../../common/media-context";
import { equals, lensPath, set } from "ramda";

import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

import DefaultContentSort from "../../../collections/edit/DefaultContentSort";
import EditCategoriesColumn from "../../../common/EditCategoriesColumn";
import EditDescriptionColumn from "../../../common/EditDescriptionColumn";
import NewOrgLogoOverlay from "../../../common/NewOrgLogoOverlay";
import NewThumbnailOverlay from "../../../common/NewThumbnailOverlay";

const useStyles = makeStyles(theme => ({
  error: {
    color: theme.palette.error.main,
    paddingTop: 5,
  },
}));

const thumbnailFileTypes = {
  anthology: "jpg, jpeg, image/jpeg, image/jpg, png, image/png",
  collection: "jpg, jpeg, image/jpeg, image/jpg, png, image/png",
};

const NewContentGroupForm = props => {
  const { mediaType, validator } = props;
  const context = useContext(MediaContext);
  const classes = useStyles();

  const [accept, setAccept] = useState("");
  useEffect(() => {
    if (mediaType) {
      setAccept(thumbnailFileTypes[mediaType]);
    }
  }, [mediaType]);

  const handleBlur = (field, value) => {
    const errors = validator.validateField(field, value);
    context.setErrors(errors);
  };

  const handleTextChange = path => event => {
    const value = event.target.value;
    context.setMedia(prev => set(lensPath(path), value, prev));
  };

  return (
    <Grid container spacing={4}>
      <Grid item>
        <NewThumbnailOverlay accept={accept} />
        {validator.hasError(context.errors, "thumbnail") && (
          <div className={classes.error}>
            {validator.firstError(context.errors, "thumbnail")}
          </div>
        )}
      </Grid>

      <Grid container item xs spacing={4} alignContent="flex-start">
        <Grid item xs={12}>
          <TextField
            id={`${mediaType}-title`}
            fullWidth
            required
            label="Title"
            value={context.media.name}
            onChange={handleTextChange(["name"])}
            error={validator.hasError(context.errors, "name")}
            helperText={validator.firstError(context.errors, "name")}
            onBlur={() => handleBlur("name", context.media.name)}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            id={`${mediaType}-subtitle`}
            fullWidth
            label="Subtitle"
            value={context.media.subName}
            onChange={handleTextChange(["subName"])}
            error={validator.hasError(context.errors, "subName")}
            helperText={validator.firstError(context.errors, "subName")}
            onBlur={() => handleBlur("subName", context.media.subName)}
          />
        </Grid>
      </Grid>

      {equals(mediaType, "collection") && (
        <Grid item xs={4}>
          <DefaultContentSort />
        </Grid>
      )}

      <Grid item xs={12} style={{ marginTop: 25 }}>
        <EditDescriptionColumn
          enableLinks
          allowHtml
          required
          error={validator.hasError(context.errors, "description")}
          helperText={validator.firstError(context.errors, "description")}
          onBlur={() => handleBlur("description", context.media.description)}
        />
      </Grid>

      {equals(mediaType, "anthology") && (
        <Fragment>
          <Grid item xs>
            <EditCategoriesColumn showFourCategories validator={validator} />
          </Grid>

          <Grid item xs="auto">
            <NewOrgLogoOverlay />
          </Grid>
        </Fragment>
      )}
    </Grid>
  );
};

export default NewContentGroupForm;
